
	// Inject config from environment variables
	const config = {
		environment: import.meta.env.VITE_ENVIRONMENT || 'development',
		listen_host: import.meta.env.VITE_LISTEN_HOST || 'localhost:8080',
		release: import.meta.env.VITE_RELEASE || 'dev',
		wisteria_url: import.meta.env.VITE_WISTERIA_URL || ''
	};
	document.getElementById('gpsh-app-root').setAttribute('config', JSON.stringify(config));
